import React from "react";
import { cleancloths, faqimg } from "../../assets/img";
import { Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";

const SectionNineThemeOne = () => {
  const jsonData: any = useSelector<any>((state) => state?.homeJsonList);
  // HTML
  return (
    <>
      <section className="faq-section">
        <div className="faq-subtract-top d-none"></div>
        <div className="faq-subtract-body">
          <div className="container-fluid">
            <div className="row justify-content-end">
              <div className="col-md-5">
                <div className="faq-content">
                  <h2 className="section-title" style={{
                      color: `#${jsonData?.theme_1?.home?.section_9?.h2color}`
                    }}>
                  {jsonData?.theme_1?.home?.section_9?.title}
                  </h2>
                  <p style={{
                      color: `#${jsonData?.theme_1?.home?.section_9?.paracolor}`
                    }}>
                  {jsonData?.theme_1?.home?.section_9?.paragraph}
                  </p>
                  <Accordion className="faq-home">
                {jsonData?.theme_1?.home?.section_9?.card_section?.collection &&
                    Object.keys(jsonData.theme_1?.home?.section_9?.card_section?.collection).map(
                      (key) => (
                      <Accordion.Item eventKey={key}>
                        <Accordion.Header>
                        {jsonData.theme_1?.home?.section_9?.card_section?.collection[key].collection_title}
                
                          </Accordion.Header>
                        <Accordion.Body>
                        {jsonData.theme_1?.home?.section_9?.card_section?.collection[key].collection_paragraph}

      
                          </Accordion.Body>
                      </Accordion.Item>
                       )
                       )}
                </Accordion>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mobapp-img mobapp-img-faq text-center">
                  <img src={jsonData?.theme_1?.home?.section_9?.banner[0]?.banner} alt="" />
                  <div className="mobapp-img-overlay">
                    <p>{jsonData?.theme_1?.home?.section_9?.card_heading}</p>
                    <h4>{jsonData?.theme_1?.home?.section_9?.card_number}</h4>
                    <a
                      href={`tel:${jsonData?.theme_1?.home?.section_9?.card_number}`}
                      className="btn secondary-btn hover-btn"
                    >
                      {jsonData?.theme_1?.home?.section_9?.card_buttontext}<i className="fas fa-chevron-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="faq-subtract-bottom d-none"></div>
      </section>
    </>
  );
};

export default SectionNineThemeOne;
